import React, { Component, PropTypes } from 'react';
import { Menu, Table, Button, Modal, Badge, Icon, Spin, Input, Form, Row, Col, Pagination } from 'antd';
import { browserHistory, Link } from 'react-router';
import _ from 'lodash';
import cn from 'classnames';
import { formatPvCode } from 'utils/formatting';
import { formItemLayout } from 'constants/layout';
import { TableHelper, exportAsExcel } from 'helpers/Table';

import { connect } from 'react-redux';
import { getWithdraws, paidWithdraw, rejectWithdraw, paidWithdraws, getAllWithdraws } from 'data/transaction';
// import { getClassListRecommend, getClassListUpcoming } from 'redux/modules/classroom';
// import { getWithdraws, getPageList, postNewPageContent } from 'redux/modules/content';
import moment from 'moment';
import Utils from 'utils/utils';

import classes from '../styles/withdrawal/Withdraw.module.scss';

import { DatePickerInput } from '../../components';
const pageLimit = 20;

const FormItem = Form.Item;
const Confirm = Modal.confirm;

class Withdraw extends Component {
  constructor(props) {
    super(props);
    this.onClickRow = this.onClickRow.bind(this);
    this.changeFocusPage = this.changeFocusPage.bind(this);
    this.onAddNewPageContent = this.onAddNewPageContent.bind(this);
    this.onPaidOrder = this.onPaidOrder.bind(this);
    this.onPaidOrders = this.onPaidOrders.bind(this);
    this.onRowSelectChange = this.onRowSelectChange.bind(this);
    this.onTableChange = this.onTableChange.bind(this);
    this.onChangePage = this.onChangePage.bind(this);
    const start = props.location.query.start ? moment(props.location.query.start, 'DD-MM-YYYY') : moment().subtract(1, 'month');
    const end = props.location.query.end ? moment(props.location.query.end, 'DD-MM-YYYY') : moment();
    this.state = {
      collapseMobile: [],
      showModal: false,
      start,
      end,
      selectedStatus: props.location.query.status ? props.location.query.status : 'all',
      searchValue: props.location.query.q ? props.location.query.q : '',
      displaySearchValue: props.location.query.q ? props.location.query.q : '',
      sortBy: props.location.query.sortBy ? props.location.query.sortBy : undefined,
      selectedRowKeys: [],
      page: 1,
    };
  }

  componentDidMount = async () => {
    const promises = [];
    const query = this.props.location.query;
    if (!query.start) {
      query.start = moment().subtract(1, 'month').format('DD-MM-YYYY');
      query.end = moment().format('DD-MM-YYYY');
    }
    this.setState({
      loading: true,
    });
    const withdrawals = await getWithdraws(query);

    this.setState({
      loading: false,
      withdraws: withdrawals.results,
      page: withdrawals.currentPage,
      count: withdrawals.count,
    });
  };

  componentWillMount() {
    this.setState({
      showModal: false,
    });
  }

  componentWillReceiveProps(props) {
    const start = props.location.query.start ? moment(props.location.query.start, 'DD-MM-YYYY') : moment().subtract(3, 'month');
    const end = props.location.query.end ? moment(props.location.query.end, 'DD-MM-YYYY') : moment();
    const newState = {
      start,
      end,
      selectedStatus: props.location.query.status ? props.location.query.status : 'all',
      searchValue: props.location.query.q ? props.location.query.q : '',
      displaySearchValue: props.location.query.q ? props.location.query.q : '',
      sortBy: props.location.query.sortBy ? props.location.query.sortBy : undefined,
    };
    this.setState(newState);
  }

  onChangePage = (page) => {
    this.setState(
      {
        page,
      },
      () => {
        this.getWithdraws(_.merge(this.getCurrentQuery(), { page }));
      },
    );
  };

  onAddNewPageContent() {
    console.log(this.state.selectedStatus);
    this.setState({
      showModal: true,
      selectedRow: {
        pageName: this.state.selectedStatus,
      },
      isAddNew: true,
    });
  }

  onPaidOrder(id) {
    Confirm({
      title: 'ยืนยันการจ่ายเงิน',
      content: '',
      onOk: () => {
        paidWithdraw(id, { status: 'paid' }).then(() => {
          this.setState({ selectedRowKeys: [] });
          this.getWithdraws(this.getCurrentQuery()).then(_.noop);
        });
      },
    });
  }

  onPaidOrders() {
    Confirm({
      title: 'ยืนยันการจ่ายเงิน',
      content: '',
      onOk: () => {
        const ids = this.state.selectedRowKeys.map((key) => {
          return this.state.withdraws[key]._id;
        });
        paidWithdraws({ ids }).then(() => {
          this.setState({ selectedRowKeys: [] });
          this.getWithdraws(this.getCurrentQuery()).then(_.noop);
        });
      },
    });
  }

  onClickRow(record, index) {
    console.log(record, index);
  }

  onRowSelectChange(selectedRowKeys) {
    this.setState({ selectedRowKeys });
  }

  onTableChange(a, b, sorter) {
    const { field, order } = sorter;
    if (order === 'descend') {
      this.setState({ sortBy: `-${field}` }, this.onSearch);
    } else if (order === 'ascend') {
      this.setState({ sortBy: field }, this.onSearch);
    }
  }

  onSearch = () => {
    this.setState(
      {
        page: 1,
        searchValue: this.state.displaySearchValue,
        selectedRowKeys: [],
      },
      () => {
        this.getWithdraws(_.merge(this.getCurrentQuery(), { page: 1 })).then(_.noop);
      },
    );
  };

  onInputSearch = (event) => {
    this.setState({
      displaySearchValue: event.target.value,
    });
  };
  onSearchInputPress(event) {
    if (event.charCode === 13) {
      this.onSearch();
    }
  }

  getCurrentQuery = () => {
    return {
      page: this.state.page || 1,
      status: this.state.selectedStatus,
      q: this.state.searchValue,
      start: this.state.start.format('DD-MM-YYYY'),
      end: this.state.end.format('DD-MM-YYYY'),
      sortBy: this.state.sortBy,
    };
  };
  getWithdraws = async (query) => {
    browserHistory.push(`${this.props.location.pathname}${Utils.createQueryString(query)}`);
    if (!query.start) {
      query.start = moment().subtract(1, 'month').format('DD-MM-YYYY');
      query.end = moment().format('DD-MM-YYYY');
    }
    this.setState({
      loading: true,
    });
    const withdrawals = await getWithdraws(query);

    this.setState({
      loading: false,
      withdraws: withdrawals.results,
      page: withdrawals.page,
      count: withdrawals.count,
    });
  };

  changeFocusPage(event) {
    const status = event.key;
    this.setState({
      selectedStatus: status,
      selectedRowKeys: [],
      page: 1,
    });
    this.getWithdraws(_.merge(this.getCurrentQuery(), { status, page: 1 })).then((response) => {
      console.log(response);
    });
  }

  exportToExcel() {
    getAllWithdraws(this.getCurrentQuery()).then((resultObj) => {
      const results = resultObj.results;
      const content = results.map((singleContent, key) => {
        singleContent.key = key;
        return singleContent;
      });
      exportAsExcel({
        filename: `WITHDRAWALS-${moment().format('DD-MM-YYYY_HH-mm-ss')}.xlsx`,
        sheetName: 'Sheet1',
        columns: this.columns,
        data: content,
      });
    });
  }

  handleCancel() {
    this.setState({
      showModal: false,
      selectedRowKeys: [],
      isAddNew: false,
      confirmDirty: false,
      getFieldDecorator: false,
      showNewPageModal: false,
    });
  }

  columns = [
    {
      ...TableHelper.datetimeColumn('Request\nDate', 'createdAt'),
      render: (value) => {
        const dateTime = value;
        return dateTime ? <span>{moment(dateTime).format('DD-MM-YYYY HH:mm')}</span> : <span />;
      },
      sorter: true,
    },
    {
      ...TableHelper.defaultColumn('Withdrawal\nCode', 'code'),
      render: (value, record) => (
        <div className="no-wrap">
          <Link to={`/withdraw/${record._id}`}>
            <span>{value} </span>
          </Link>
          {record.remark && <Icon type="pushpin" />}
        </div>
      ),
      sorter: true,
    },
    {
      ...TableHelper.defaultColumn('Teacher\nName', 'teacher.displayName'),
      render: (value, record) => {
        const { first, last } = record.teacher.name;
        return (
          <div>
            <Link to={`/teacher/${_.get(record, 'teacher._id')}`}>{`${first} ${last}`}</Link>
            {record.teacher.remark && <Icon type="pushpin" />}
          </div>
        );
      },
    },
    {
      ...TableHelper.defaultColumn('Bank', 'bankName'),
      render: (value) => {
        return <span>{value}</span>;
        // const bankName = _.get(record, 'paymentDetail.bankName');
        // return bankName ? <span>{bankName}</span> : <span />;
      },
    },
    {
      ...TableHelper.defaultColumn('To A/C No.', 'bankAccount'),
      render: (value) => {
        return <span>{value}</span>;
        // const bankName = _.get(record, 'paymentDetail.bankName');
        // return bankName ? <span>{bankName}</span> : <span />;
      },
    },
    {
      ...TableHelper.priceColumn('Payout', 'withdrawAmount'),
    },

    {
      ...TableHelper.datetimeColumn('Tran.\nDate', 'approvedDate'),
      render: (value) => {
        const dateTime = value;
        return dateTime ? <span>{moment(dateTime).format('DD-MM-YYYY HH:mm')}</span> : <span />;
      },
      sorter: true,
    },
    {
      ...TableHelper.defaultColumn('PV No.', 'pvCode'),
      render: (value, record) => {
        return formatPvCode(record);
      },
      renderExcel: (value, record) => formatPvCode(record),
      sorter: true,
    },
    {
      ...TableHelper.defaultColumn('Status', 'status'),
      render: (value) => (
        <div>
          {value === 'pending' && <Badge status="default" text="Pending" />}
          {value === 'paid' && <Badge status="processing" text="Paid" />}
          {value === 'rejected' && <Badge status="error" text="Rejected" />}
        </div>
      ),
      sorter: true,
    },

    {
      title: '',
      dataIndex: '',
      render: (value, record) => (
        <div>
          {(record.status === 'pending' || record.status === 'confirm') && (
            <Button type="success" onClick={() => this.onPaidOrder(record._id)}>
              Paid
            </Button>
          )}
        </div>
      ),
    },
  ];

  withdrawStatuses = [
    { label: 'All', value: 'all' },
    { label: 'Pending', value: 'pending' },
    { label: 'Paid', value: 'paid' },
    { label: 'Rejected', value: 'rejected' },
  ];

  renderPageTopMenu() {
    return (
      <Menu onClick={this.changeFocusPage} selectedKeys={[this.state.selectedStatus]} mode="horizontal" className={classes.menu}>
        {this.withdrawStatuses &&
          this.withdrawStatuses.map((singleClass) => (
            <Menu.Item key={singleClass.value} className={classes.dashRight}>
              <div>{singleClass.label} </div>
            </Menu.Item>
          ))}
      </Menu>
    );
  }

  renderContentTable() {
    const content = _.map(this.state.withdraws, (singleContent, key) => {
      singleContent.key = key;
      return singleContent;
    });
    const { selectedRowKeys } = this.state;
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onRowSelectChange,
      hideDefaultSelections: true,
    };
    return (
      <div>
        <Table
          columns={this.columns}
          dataSource={content}
          bordered
          pagination={false}
          onRowClick={this.onClickRow}
          rowSelection={this.state.selectedStatus === 'pending' ? rowSelection : undefined}
          onChange={this.onTableChange}
          scroll={{ x: 1500 }}
        />
        <Pagination className={cn(classes.pagination, 'text-right')} current={this.state.page} onChange={this.onChangePage} defaultPageSize={pageLimit} total={this.state.count} />
      </div>
    );
  }

  render() {
    return (
      <div>
        <div className="page-header">{this.props.BreadCrumb}</div>
        <div className="content">
          <Spin tip="Loading" size="large" spinning={!!this.state.loading}>
            {this.renderPageTopMenu()}
            <div>
              <div className={classes.searchContainer}>
                <Row>
                  <Col xs={7} className={classes.searchInputContainer}>
                    <Input prefix={<Icon type="search" />} placeholder="Search" onKeyPress={(e) => this.onSearchInputPress(e)} onChange={(e) => this.onInputSearch(e)} />
                  </Col>
                  <Col xs={7}>
                    <DatePickerInput start={this.state.start} end={this.state.end} onChange={(momentDates) => this.setState({ start: momentDates[0], end: momentDates[1] })} />
                  </Col>

                  <Button className="search-btn" onClick={this.onSearch}>
                    <Icon type="search" />
                  </Button>
                </Row>
              </div>
              <div className={classes.topCommand}>
                <div className={'pull-right'}>
                  <a onClick={() => this.exportToExcel()}>
                    <Icon type="file-excel" /> Export to excel
                  </a>
                </div>
                <div>
                  {this.state.selectedRowKeys.length > 0 && this.state.selectedStatus === 'pending' && (
                    <Button type="success">
                      <a onClick={() => this.onPaidOrders()}>Paid Selected ({this.state.selectedRowKeys.length})</a>
                    </Button>
                  )}
                </div>
              </div>
            </div>

            {this.renderContentTable()}
          </Spin>
        </div>
      </div>
    );
  }
}
export default connect((state) => ({}), { getWithdraws, paidWithdraw, paidWithdraws, rejectWithdraw, getAllWithdraws })(Form.create()(Withdraw));
